import React, { useState } from "react";
import Switcher from "./Components/Switcher/Switcher";
import FactSheetCard from "./Components/FactSheetCard/FactSheetCard";
import { FactSheetCardData } from "./InsightsData";

const options = [
  "All",
  "Compliance",
  "BCM",
  "Fraud",
  "GRC",
  "Outsourcing Risk",
];
const FactSheetPage = () => {
  const [activeOption, setActiveOption] = useState("All");
  const combinedData =
    activeOption === "All"
      ? [
          ...FactSheetCardData["All"],
          ...FactSheetCardData["Compliance"],
          ...FactSheetCardData["BCM"],
          ...FactSheetCardData["Fraud"],
          ...FactSheetCardData["GRC"],
          ...FactSheetCardData["Outsourcing Risk"],
        ]
      : //@ts-ignore
        FactSheetCardData[activeOption];

  return (
    <div>
      <Switcher
        options={options}
        current={activeOption}
        onChange={setActiveOption}
      />
      <div className="blogCardCnt">
        {/* @ts-ignore */}
        {combinedData?.map(
          // @ts-ignore
          ({ heading, img }) => (
            <FactSheetCard img={img} heading={heading} />
          )
        )}
      </div>
    </div>
  );
};

export default FactSheetPage;
